class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    // Add event listeners for all close buttons
    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      if (closeButton.classList.contains('cart-notification__continue')) {
        closeButton.addEventListener('click', () => {
          this.close();
        });
      } else {
        closeButton.addEventListener('click', this.close.bind(this));
      }
    });

    // Add animation end listener
    this.notification.addEventListener('animationend', this.handleAnimationEnd.bind(this));
  }

  open() {
    // Ensure any previous animations are cleared
    this.notification.classList.remove('animate-out');
    
    // Add animation classes
    this.notification.classList.add('animate', 'animate-in', 'active');
    
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    // Add animation out class
    this.notification.classList.add('animate-out');
    this.notification.classList.remove('animate-in');
    
    // The actual removal of 'active' class will be handled by the animationend event
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  handleAnimationEnd(evt) {
    if (evt.animationName === 'slideOutUp' || this.notification.classList.contains('animate-out')) {
      this.notification.classList.remove('active', 'animate-out');
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    
    // Update cart notification sections
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    
    // Show header if it exists
    if (this.header) this.header.reveal();
    
    // Open the notification
    this.open();
    
    // Fetch the current cart to get the accurate price
    this.fetchCartAndUpdatePrice();
    
    // Update cart count if element exists
    const countEl = document.getElementById('cart-notification-count');
    if (countEl && typeof parsedState.item_count !== 'undefined') {
      countEl.textContent = ` (${parsedState.item_count})`;
    }
    
    // Auto-close after 5 seconds if not interacted with
    this.autoCloseTimeout = setTimeout(() => {
      if (this.notification.classList.contains('active') && 
          !this.notification.matches(':hover') && 
          !this.notification.contains(document.activeElement)) {
        this.close();
      }
    }, 5000);
  }

  fetchCartAndUpdatePrice() {
    fetch(`${window.location.origin}/cart.js`)
      .then(response => response.json())
      .then(cart => {
        // Show the price row now that we have accurate data
        const priceRow = document.getElementById('cart-notification-price');
        if (priceRow) {
          priceRow.style.display = 'flex';
        }
        
        // Update the subtotal with the accurate price
        const subtotalEl = document.getElementById('cart-notification-subtotal');
        if (subtotalEl && cart.total_price) {
          subtotalEl.textContent = this.formatMoney(cart.total_price, cart.currency);
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  // Formats in the store's own money format (passed in from Liquid via
  // data-money-format), so the symbol and separators match the rest of the store.
  formatMoney(cents, currency) {
    const value = Number(cents) / 100;
    const format = (this.dataset.moneyFormat || '').replace(/<[^>]*>/g, '');

    if (!format) {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'EUR',
      }).format(value);
    }

    const fmt = (decimals, thousands, decimal) => {
      const [whole, frac] = value.toFixed(decimals).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? grouped + decimal + frac : grouped;
    };

    const formats = {
      amount: () => fmt(2, ',', '.'),
      amount_no_decimals: () => fmt(0, ',', '.'),
      amount_with_comma_separator: () => fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => fmt(0, '.', ','),
      amount_with_space_separator: () => fmt(2, ' ', ','),
      amount_no_decimals_with_space_separator: () => fmt(0, ' ', ','),
      amount_with_apostrophe_separator: () => fmt(2, "'", '.'),
      amount_with_period_and_space_separator: () => fmt(2, ' ', '.'),
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (formats[key] || formats.amount)());
  }
}

customElements.define('cart-notification', CartNotification);